"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

/** @class FormMessage
 * @desc A private component shared between form components which display a validation error.
 *
 * @param {string} [data-id]
 *    Optional data-id
 * @param {node} [message]
 *    The message text to display
 * @param {string} [type=error]
 *    The type of message (error = red, info = blue, success = green, warning = yellow)
 *
 * @private
 */
var messageTypes = {
  ERROR: "error",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning"
};

var FormMessage = function FormMessage(_ref) {
  var _context, _context2;

  var dataId = _ref["data-id"],
      message = _ref.message,
      type = _ref.type;
  var typeName = messageTypes[type] || messageTypes.ERROR;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-message",
    "data-id": dataId
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-id": (0, _concat.default)(_context = "".concat(dataId, "-")).call(_context, typeName, "-message-icon"),
    className: "input-message__icon"
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-id": (0, _concat.default)(_context2 = "".concat(dataId, "-")).call(_context2, typeName, "-message"),
    className: "input-message__text"
  }, message));
};

FormMessage.defaultProps = {
  "data-id": "form-message",
  type: messageTypes.ERROR
};
FormMessage.propTypes = {
  "data-id": _propTypes.default.string,
  type: _propTypes.default.oneOf([messageTypes.ERROR, messageTypes.INFO, messageTypes.SUCCESS, messageTypes.WARNING])
};
FormMessage.messageTypes = messageTypes;
var _default = FormMessage;
exports.default = _default;
module.exports = exports["default"];